import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material';

//declare let $: any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css', '../../../../assets/css/core-login.css']
})
export class FooterComponent {
  constructor(public dialog: MatDialog) {}

  openDialogPrivacy() {
    this.dialog.open(PrivacyComponentDialog, {
      width: '55%'
    });
  }

  openDialogTerms() {
    this.dialog.open(TermsComponentDialog, {
      width: '55%'
    });
  }
}

@Component({
  selector: 'app-dialog',
  templateUrl: 'dialogprivacypolicy.html',
  styleUrls: ['./footer.component.css', '../../../../assets/css/core-login.css']
})
export class PrivacyComponentDialog {}

@Component({
  selector: 'app-dialog',
  templateUrl: 'dialogtermsofuse.html',
  styleUrls: ['./footer.component.css', '../../../../assets/css/core-login.css']
})
export class TermsComponentDialog {}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/layout/footer/footer.component.ts